/** Consistent browser console tracing for the Blockbrain chat path. */
const PREFIX = "[Blockbrain]";

function stamp(extra?: Record<string, unknown>) {
  return {
    t: new Date().toISOString(),
    ...extra,
  };
}

export function bbLog(step: string, detail?: Record<string, unknown>) {
  if (detail) {
    console.log(PREFIX, step, stamp(detail));
  } else {
    console.log(PREFIX, step, stamp());
  }
}

export function bbWarn(step: string, detail?: Record<string, unknown>) {
  if (detail) {
    console.warn(PREFIX, step, stamp(detail));
  } else {
    console.warn(PREFIX, step, stamp());
  }
}

export function bbError(step: string, detail?: Record<string, unknown>) {
  if (detail) {
    console.error(PREFIX, step, stamp(detail));
  } else {
    console.error(PREFIX, step, stamp());
  }
}

export function previewText(text: string | undefined | null, max = 120): string {
  if (!text) return "";
  const trimmed = text.replace(/\s+/g, " ").trim();
  return trimmed.length <= max ? trimmed : `${trimmed.slice(0, max)}…`;
}
